module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.showDetails()) ? [_c('div', {
    staticClass: "subheading grey--text text--darken-1 pl-4 pb-2"
  }, [_vm._v("Details")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-card-media', {
    attrs: {
      "height": "125px",
      "contain": "",
      "src": _vm.provider.Logo
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [_c('div', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.provider.Name))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "label grey--text text--darken-1",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("Link type")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_vm._v(_vm._s(_vm.provider.LinkType))])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "label grey--text text--darken-1",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("Authorize url")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_vm._v(_vm._s(_vm.provider.AuthorizeUrl))])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "label grey--text text--darken-1",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("Client ID")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_vm._v(_vm._s(_vm.provider.ClientId))])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "label grey--text text--darken-1",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("Token url")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_vm._v(_vm._s(_vm.provider.TokenUrl))])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "label grey--text text--darken-1",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("Profile format")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_vm._v(_vm._s(_vm.provider.ProfileFormat))])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "label grey--text text--darken-1",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("scopes")]), _vm._v(" "), (_vm.provider.Scopes) ? _c('div', _vm._l((_vm.provider.Scopes.split(' ')), function(scope) {
    return _c('v-chip', {
      key: scope
    }, [_vm._v("\n                                            " + _vm._s(scope) + "\n                                        ")])
  })) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "subheading grey--text text--darken-1 pl-4 pt-4 pb-2"
  }, [_vm._v("Schemas")]), _vm._v(" "), (_vm.schemas.length === 0) ? _c('div', {
    staticClass: "text-xs-center pt-2 pb-2 grey--text text--darken-1"
  }, [_vm._v("\n            No schemas\n        ")]) : [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-list', {
    attrs: {
      "one-line": ""
    }
  }, _vm._l((_vm.schemas), function(item, index) {
    return _c('v-list-group', {
      key: item.Version,
      on: {
        "click": function($event) {}
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "item",
        "avatar": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          _vm.schema(item.Version)
        }
      },
      slot: "item"
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("fa-code-fork")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(item.Version))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', [_c('v-btn', {
      staticClass: "grey--text text--lighten-2",
      attrs: {
        "icon": "",
        "ripple": "",
        "href": item.DocUrl,
        "target": "_blank"
      }
    }, [_c('v-icon', [_vm._v("fa-book")])], 1)], 1)], 1)], 1)], 1)
  }))], 1)], 1)], 1)]] : _vm._e(), _vm._v(" "), (_vm.showEndpoints()) ? [_c('div', {
    staticClass: "subheading grey--text text--darken-1 pl-4 pb-2"
  }, [_vm._v("Endpoints")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, _vm._l((_vm.endpoints), function(item, index) {
    return _c('v-list-group', {
      key: item.Code,
      on: {
        "click": function($event) {}
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "item",
        "avatar": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          _vm.endpoint(item.Code)
        }
      },
      slot: "item"
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("fa-code-fork")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(item.Code))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.ShortDescription))])], 1), _vm._v(" "), (_vm.hasDoc(item)) ? _c('v-list-tile-action', [_c('v-list-tile-action-text', [_c('v-btn', {
      staticClass: "grey--text text--lighten-2",
      attrs: {
        "icon": "",
        "ripple": "",
        "href": item.DocUrl,
        "target": "_blank"
      }
    }, [_c('v-icon', [_vm._v("fa-book")])], 1)], 1)], 1) : _vm._e()], 1)], 1)
  }))], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.showMappings()) ? [_c('div', {
    staticClass: "subheading grey--text text--darken-1 pl-4 pb-2"
  }, [_vm._v("Mappings")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, _vm._l((_vm.mappings), function(item, index) {
    return _c('v-list-group', {
      key: item.ResponsePath,
      on: {
        "click": function($event) {}
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "item",
        "avatar": "",
        "ripple": ""
      },
      slot: "item"
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("fa-code-fork")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(item.ResponsePath))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.Description))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', [_vm._v("\n                                    " + _vm._s(item.PropertyId) + "\n                                ")])], 1)], 1)], 1)
  }))], 1)], 1)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70305a28","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ProfileProvider.vue
// module id = 394
// module chunks = 0